<div
  fxLayout="row wrap"
  fxLayoutAlign="center start"
  fxLayoutGap="10px"
>
  <mmx-action-card
    *ngFor="let location of locations"
    class="location-card mb-15"
    [selected]="isLocationSelected(location)"
    [unselectable]="multiple"
    (selectedChange)="onLocationPicked(location)"
  >
    <div fxLayout="column">
      <h5 class="m-0 font-light"> {{ location.name }} </h5>
      <div class="m-0 description">
        <h6 class="mt-10"><b>{{ 'home.facilities.address' | translate }}</b></h6>
        <ng-container matLine>
          <ng-container *ngIf="location.address">
            <address>{{ location.address | address:true }}</address>
            <a
              [href]="location.mapLink"
              target="_blank"
              class="text-link"
            >
              {{ 'appointment-schedule.location.open-map' | translate }}
            </a>
          </ng-container>
        </ng-container>

        <mmx-location-working-hours
          *ngIf="location.timing?.workingDays"
          [workingDays]="location.timing?.workingDays || {}"
          [timezone]="location.timezone || 'America/New_York'"
        ></mmx-location-working-hours>
      </div>
    </div>
  </mmx-action-card>
</div>
